<!--
 * @Author: DY
 * @Date: 2025-03-07 14:18:00
 * @LastEditTime: 2025-03-21 11:40:24
 * @Description: 铁路货运单签收【运输管理】
 * @FilePath: \ShiMo_Mobile\src\views\transport\railwayBillSignFor\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="railwayBillSignFor commonListStyles">
            <van-nav-bar
                left-arrow
                left-text="应用"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
                @click-right="rightClickFun"
            >
                <template #title>
                    <div :class="{'active': listType == '2'}" @click="listSwitch('2')">
                        待签收
                    </div>
                    <div :class="{'active': listType == '3'}" @click="listSwitch('3')">
                        已签收
                    </div>
                </template>
                <template #right>
                    <span class="iconfont sm-shaixuan11"></span>
                </template>
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">铁运单号：{{ item.transport_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>客户名称：{{ item.client_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>发货日期：{{ item.loading_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3@2x.png" alt="">
                                            <span>到站：{{ item.arrive_station }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>货物名称：{{ item.material_short_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_16@2x.png" alt="">
                                            <span>数量：{{ item.delivery_weight }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" v-if="listType == 2" @click="signFor(item)">
                                            签收
                                        </van-button>
                                        <van-button
                                            plain type="danger"
                                            v-if="item.status == 2 && (item.objection_handle_status = null || [0, 2].includes(item.objection_handle_status))"
                                            @click="toDetail(item, 'edit')"
                                        >
                                            编辑
                                        </van-button>
                                        <van-button plain type="danger" v-else @click="toDetail(item, 'view')">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>铁运单号</dt>
                            <dd>
                                <van-field v-model="params.transport_number" placeholder="输入出库单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>客户名称</dt>
                            <dd>
                                <van-field v-model="params.client_name" placeholder="输入出库单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同编号</dt>
                            <dd>
                                <van-field v-model="params.material" placeholder="输入出库单号"></van-field>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'railway-bill-sign-for',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'railway-bill-sign-for');
        }
        next();
    },
    data() {
        return {
            listType: '2',
            tableCode: 'transport_railway_sign',
            popupShow: false,
            params: {
                transport_number: '',
                client_name: '',
                material: '',
            },
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        rightClickFun() {
            this.popupShow = true;
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                delivery_status: this.listType,
                transport_number: this.params.transport_number,
                client_name: this.params.client_name,
                material: this.params.material,
            };
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.params.transport_number = '';
            this.params.client_name = '';
            this.params.material = '';
        },
        // 待办已办切换
        listSwitch(obj) {
            this.pageIndex = 0;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.initPage();
        },
        // 签收
        async signFor(item) {
            this.$dialog.confirm({
                message: `确认签收出铁路货运单【${item.transport_number}】吗？`,
            }).then(async () => {
                const res = await this.signForRequest(item.id);
                if (res) {
                    this.$toast('签收成功！');
                    this.onRefresh();
                }
            });
        },
        toDetail(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'railwayBillSignForForm',
                params: {
                    type,
                    data: item,
                },
            });
        },
        // 签收请求
        signForRequest(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_railway_sign?id=${id}`);
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.railwayBillSignFor
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
